import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ServiceRequest, ServiceRequestResponse } from "./types";

export interface ServiceRequestsState {
  uuid: string;
  serviceRequests: ServiceRequest[];
  serviceRequestData: ServiceRequestResponse;
  serviceRequestDataStatus: string;
}

const initialState: ServiceRequestsState = {
  uuid: "",
  serviceRequests: [],
  serviceRequestData: {
    first_name: "",
    last_name: "",
    policy_carrier: "",
    policy_type: "auto",
    policy_number: "",
    description: "",
    preferred_contact_method: "email",
    request_type: "policy_change",
    email: "",
    phone: "",
    due_date: "",
    status: "new",
    files: [],
    created_at: "",
    updated_at: "",
    agency: {
      id: 0,
      name: "",
    },
    user: undefined,
    id: 0,
    uuid: "",
    agency_id: 0,
    user_id: null,
    communications: [],
    notes: [],
  },
  serviceRequestDataStatus: "",
};

export const serviceRequests = createSlice({
  name: "serviceRequests",
  initialState,
  reducers: {
    setServiceRequestUUID(state, { payload }: PayloadAction<string>) {
      state.uuid = payload;
    },
    setServiceRequests(state, { payload }: PayloadAction<ServiceRequest[]>) {
      state.serviceRequests = payload;
    },
    setServiceRequest(
      state,
      { payload }: PayloadAction<ServiceRequestResponse>,
    ) {
      state.serviceRequestData = payload;
    },
    setServiceRequestStatus(state, { payload }: PayloadAction<string>) {
      state.serviceRequestDataStatus = payload;
    },
  },
});
